import {BaseCachedService} from './Core/BaseCachedService';

class SpeciesInvasivityService extends BaseCachedService {
    get Url() { return super.Url + "/speciesInvasivities"; }
    get ModelName() { return "Species Invasivity"; }
    get PrimaryKeyProperty() { return "speciesInvasivityId"; }
    
    GetTitle(model) {
        if(model?.speciesInvasivityId == null) {
            return "Unspecified";
        }
        return super.GetTitle(model);
    }
}

export const service = new SpeciesInvasivityService();

